import Main from '@/components/main';

export default {
    path: '/master-management',
    name: 'master-management',
    meta: {
        icon: 'ios-flag',
        title: '专家管理',
        showAlways: true,
        hideInMenu: true
    },
    component: Main,
    children: [
        {
            path: 'standardCard-list',
            name: 'standardCard-list',
            meta: {
                icon: 'md-cube',
                title: '标准卡管理',
                notCache: false,
                access: ['A'],
                items: [
                ]
            },
            component: () => import('@/view/product-management/standardCard-management/standardCard-list')
        },
        {
            path: 'master-productApprove-list',
            name: 'master-productApprove-list',
            meta: {
                icon: 'md-cube',
                title: '产品审批记录',
                notCache: false,
                access: ['A'],
                items: [
                ]
            },
            component: () => import('@/view/product-management/productApprove-management/productApprove-list')
        },
        // {
        //     path: 'master-sale-approve-list',
        //     name: 'master-sale-approve-list',
        //     meta: {
        //         icon: 'md-people',
        //         title: '销售申请审批',
        //         notCache: true,
        //         access: ['A'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/sale-management/sale-approve/sale-approve-list')
        // },
        {
            path: 'master-qualify-fail-report-list',
            name: 'master-qualify-fail-report-list',
            meta: {
                icon: 'ios-medical',
                title: '质检不合格仲裁',
                notCache: true,
                access: ['A'],
                items: [
                ]
            },
            component: () => import('@/view/warehouse-management/qualifyFail-report/qualifyFail-report-list')
        }
    ]
};
